import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Hurricane"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5ZM10.0087 5.55C10.6537 5.35062 11.325 5.24949 12 5.25C15.7262 5.25413 18.7459 8.27379 18.75 12C18.75 22.38 5.385 22.5 5.25 22.5V21C7.34759 20.9391 9.42156 20.5397 11.3918 19.8172C12.3122 19.4724 13.1856 19.0131 13.9913 18.45C11.9433 19.0823 9.71686 18.7044 7.99225 17.4318C6.26764 16.1593 5.24988 14.1433 5.25 12C5.25 1.62 18.615 1.5 18.75 1.5L18.7507 3C16.6529 3.06073 14.5787 3.46013 12.6082 4.18275C11.6878 4.52759 10.8144 4.98695 10.0087 5.55ZM6.75 12C6.75 14.8995 9.10051 17.25 12 17.25C14.8981 17.2467 17.2467 14.8981 17.25 12C17.25 9.1005 14.8995 6.75 12 6.75C9.10051 6.75 6.75 9.1005 6.75 12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Hurricane.vue"]]);
